const getBase64 = (file, onLoad) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    onLoad(reader.result);
  };
};

export default getBase64;
